import { Button, ControlLabel, Form, FormControl, FormGroup, Modal } from 'rsuite';

import { LoadingSpinerArea } from '../../../../../../components/LoadingSpinner';
import styles from './ModalSaveFilters.module.scss';

export type ModalSaveFiltersProps = {
  onChangeName: (value: string) => void;
  onClickConfirm: () => void;
  onHide: () => void;
  show?: boolean;
  nameFilter?: string;
};

export const ModalSaveFilters = ({ show, nameFilter, onHide, onChangeName, onClickConfirm, ...props }: ModalSaveFiltersProps) => (
  <Modal className={styles['modal-save-filters']} show={show} {...props} onHide={onHide}>
    <Modal.Header>
      <Modal.Title>Salvar filtro</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Form fluid>
        <FormGroup>
          <ControlLabel>Nome do filtro</ControlLabel>
          <FormControl name="nome" value={nameFilter} onChange={onChangeName} />
        </FormGroup>
      </Form>
    </Modal.Body>
    <Modal.Footer>
      <Button appearance="primary" onClick={onClickConfirm}>
        Salvar filtro
      </Button>
      <Button onClick={onHide} appearance="default">
        Descartar
      </Button>
    </Modal.Footer>
    <LoadingSpinerArea size="sm" area="save-omnichannel-filter" />
  </Modal>
);
